import React from 'react';
import Button from '@amzn/awsui-components-console/button';
import Container from '@amzn/awsui-components-console/container';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Box from '@amzn/awsui-components-console/box';
import { Namespace } from 'src/generated/graphql';
import InfoTooltip from 'src/common/ui/InfoTooltip';
import NamespaceMetadataCard from 'src/features/namespace/components/NamespaceMetadataCard';

const NAMESPACE_TOOLTIP =
  'A namespace organizes string groups for a specific product or team.';

interface NamespaceHeaderProps {
  namespace: Namespace | undefined;
  onCreateStringGroup: () => void;
}

/** Displays namespace metadata in a header card with key-value pairs. */
const NamespaceHeader: React.FC<NamespaceHeaderProps> = ({
  namespace,
  onCreateStringGroup,
}) => {
  return (
    <SpaceBetween size="s">
      <Container>
        <Box display="inline-block">
          <SpaceBetween size="xs">
            <Box variant="h1" fontSize="heading-xl" fontWeight="bold">
              <SpaceBetween direction="horizontal" size="xs" alignItems="start">
                <Box variant="span" fontSize="heading-xl" fontWeight="bold">
                  {namespace?.namespaceId}
                </Box>
                <Box margin={{ top: 'xs' }}>
                  <InfoTooltip content={NAMESPACE_TOOLTIP} />
                </Box>
              </SpaceBetween>
            </Box>
            <Box variant="p" color="text-body-secondary">
              Create and manage your string groups here.
            </Box>
            <Box
              {...(namespace?.defaultCxFamily && { margin: { top: 'xxxl' } })}
              padding={{ top: 'xxxl' }}
            >
              <Button variant="primary" onClick={onCreateStringGroup}>
                Create string group
              </Button>
            </Box>
          </SpaceBetween>
        </Box>

        <Box float="right" padding="xs" margin={{ bottom: 'xxl' }}>
          <NamespaceMetadataCard
            cxFamily={namespace?.defaultCxFamily}
            bindleLabel={namespace?.bindleResourceId}
            bindleHref={
              namespace?.bindleResourceId
                ? `https://bindles.amazon.com/resource/${namespace.bindleResourceId}`
                : undefined
            }
            createdAt={namespace?.createdAt}
            createdBy={namespace?.createdBy}
          />
        </Box>
      </Container>
    </SpaceBetween>
  );
};

export default NamespaceHeader;
